import { render, staticRenderFns } from "./LpuNotWorkingLabel.vue?vue&type=template&id=4108d3bb&scoped=true&"
import script from "./LpuNotWorkingLabel.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuNotWorkingLabel.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuNotWorkingLabel.vue?vue&type=style&index=0&id=4108d3bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4108d3bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4108d3bb')) {
      api.createRecord('4108d3bb', component.options)
    } else {
      api.reload('4108d3bb', component.options)
    }
    module.hot.accept("./LpuNotWorkingLabel.vue?vue&type=template&id=4108d3bb&scoped=true&", function () {
      api.rerender('4108d3bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuNotWorkingLabel/LpuNotWorkingLabel.vue"
export default component.exports